import Alpine from "alpinejs"

export default (commonView) =>
  ({ formFields } = {}) => ({
    ...commonView({ formFields }),

    init() {
      this.commonInit()

      this.store.internalTracker.isUserIdentified({}, "klaviyo").then((isIdentified) => {
        if (!isIdentified) {
          this.store.internalTracker.trackIdentify({
            customData: { email: this.store.values.email },
            destinationService: "klaviyo",
            callBackFn: () => {
              this.store.internalTracker.trackPageView({}, "klaviyo")
            },
          })
        }
      })
    },

    updateAndTrack({ field, value, clickName = "Continue Clicked" }) {
      this.store.internalTracker.setEventToSessionStorage({ clickName })
      this.update(field, value)
    },

    goNextAndTrack(clickName = "Continue Clicked") {
      this.store.internalTracker.setEventToSessionStorage({ clickName })
      this.goNext()
    },
  })
